import Rellax from 'rellax'


document.addEventListener("DOMContentLoaded", function () {
var rellax = new Rellax('.rellax');
});